// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.termDeposit.productName || 'Create new'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li
        ng-click="\$ctrl.sectionType = 'general'"
        ng-class="{'active': \$ctrl.sectionType === 'general'}">
        <a>
          <i ng-show="\$ctrl.generalForm.\$invalid" class="icon icon-warning-sign"></i>
          General
        </a>
      </li>
      <li
        ng-click="\$ctrl.sectionType = 'interest'"
        ng-class="{'active': \$ctrl.sectionType === 'interest'}">
        <a>
          <i ng-show="\$ctrl.interestBoardsForm.\$invalid" class="icon icon-warning-sign"></i>
          Interests
        </a>
      </li>
      <li
        ng-click="\$ctrl.sectionType = 'charges'"
        ng-class="{'active': \$ctrl.sectionType === 'charges'}">
        <a>
          <i ng-show="\$ctrl.chargesForm.\$invalid" class="icon icon-warning-sign"></i>
          Fees and charges
        </a>
      </li>
      <li
        ng-click="\$ctrl.sectionType = 'advanced'"
        ng-class="{'active': \$ctrl.sectionType === 'advanced'}">
        <a>
          <i ng-show="\$ctrl.advancedForm.\$invalid" class="icon icon-warning-sign"></i>
          Advanced
        </a>
      </li>
      <li ng-if="\$ctrl.termDeposit.id"
          ng-click="\$ctrl.sectionType = 'mappings'"
          ng-class="{'active': \$ctrl.sectionType === 'mappings'}">
        <a>GL mappings</a>
      </li>
      <li ng-if="!\$ctrl.termDeposit.id" class="disabled"><a>GL mappings</a></li>
    </ul>
  </div>

<!-- SECTION -->

<term-deposit-section
  ng-if="\$ctrl.sectionType !== 'mappings'"
  deposit="\$ctrl.termDeposit"
  section-type="\$ctrl.sectionType"
  general-form="\$ctrl.generalForm"
  charges-form="\$ctrl.chargesForm"
  advanced-form="\$ctrl.advancedForm"
  branches="\$ctrl.branches">
</term-deposit-section>

<div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'interest'">

  <div class="alert">
    Please note: In case of duplicated or missing rows default interest rate will be used for calculation
  </div>

  <form name="\$ctrl.interestBoardsForm">
    <interest-board ng-repeat="board in \$ctrl.termDeposit.interestBoards" board="board">
    </interest-board>
  </form>
</div>

<div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'mappings'" ng-if="\$ctrl.productDefinition">
  <gl-mappings
    product-type="\$ctrl.productDefinition"
    custom-fees="\$ctrl.termDeposit.feeDefinitions"
    instance-ready="\$ctrl.setGlMappingComponent(instance)">
  </gl-mappings>
</div>

<!-- BUTTONS -->

<div class="clearfix"></div>

<div class="buttons" ng-if="!\$ctrl.chargesForm.wizardMode">
  <button
    class="btn btn-warning"
    ng-click="\$ctrl.cancelChanges()">
    Cancel
  </button>
  <button
    type="submit"
    class="btn btn-primary"
    ng-disabled="\$ctrl.generalForm.\$invalid || \$ctrl.interestBoardsForm.\$invalid || \$ctrl.chargesForm.\$invalid || \$ctrl.mappingsForm.\$invalid || \$ctrl.advancedForm.\$invalid"
    ng-click="\$ctrl.saveDeposit()">
    Save
  </button>
</div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/term-deposit/details/term-deposit-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;